import UniteDetailController from './unite.detail.controller';

export default {
    template: require('./unite.detail.html'),
    controller: UniteDetailController
};
